export default {
  SET_EXPIRED_TIER(state, data) {
    state.expiredTier = data;
  },
  SET_IS_TRIAL(state, data){
    state.isTrial = data;
  }
}